import React from 'react'
import { ChartBarHorizontalCustom, Legend } from '../../../../components'
import { LEGEND_COLOR_MAP, GRAPH_COLOR_PALLET2, GRAPH_COLOR_PALLET4 } from '../../../../constants'
import { getObjectAsArray } from '../../../../util'
import {
  BarWrap,
  ContentWrap,
  LegendWrap,
  SegmentRow,
  SegmentRowContent,
  SegmentWrap,
} from './style'

const BuyerTable = ({
  data,
  isExtraColor = false,
  colorPallet = [],
  showLegendToolTip = false,
}) => {
  const rowData = (rowItem) => {
    const obj = {}
    for (let index = 0; index < rowItem.length; index++) {
      const element = rowItem[index]
      obj[index + ''] = element?.SegmentValue
    }
    return [obj]
  }
  const legendDataArray = []
  const legendData = () => {
    const labelArray = data?.[0].SecondarySegmentSet?.SecondarySegment || []
    const arr = []
    for (let index = 0; index < labelArray.length; index++) {
      const obj = {
        label: labelArray[index]?.SegmentName || '',
        value: index,
      }
      legendDataArray.push(obj.label)
      arr.push(obj)
    }
    return arr
  }

  // let colors = isExtraColor ? GRAPH_COLOR_PALLET2 : LEGEND_COLOR_MAP;
  let colors = GRAPH_COLOR_PALLET4
  if (colorPallet.length > 0) {
    colors = colorPallet
  }

  return (
    <ContentWrap>
      {!!data?.length && (
        <SegmentWrap>
          {data.map((item, index) => {
            const colorDataArray =
              getObjectAsArray(item?.SecondarySegmentSet?.SecondarySegment) || []
            if (colorDataArray.length > 0) {
              const colorDataArrayObject = colorDataArray
                .map((d) => d.SegmentName)
                .includes('Positive' || 'Neutral' || 'Mixed' || 'Negative')
              if (colorDataArray && colorDataArrayObject) {
                colors = colorDataArrayObject ? LEGEND_COLOR_MAP : colors
                for (let c = 0; c < colorDataArray.length; c++) {
                  colors[c] = LEGEND_COLOR_MAP[colorDataArray[c].SegmentName]
                }
              }
            }

            return (
              <SegmentRow className='list' key={index} data-age={item.PrimarySegmentName}>
                <SegmentRowContent>
                  <BarWrap className={item?.type?.toLowerCase()}>
                    <ChartBarHorizontalCustom
                      showInside={true}
                      bottomText={false}
                      data={rowData(item?.SecondarySegmentSet?.SecondarySegment)}
                      valueInPercent
                      colorMap={colors}
                      maxPercentRatio={100}
                      maxWidth='100%'
                      showLegendToolTip={showLegendToolTip}
                      showLegendToolTipData={legendDataArray}
                    />
                  </BarWrap>
                </SegmentRowContent>
              </SegmentRow>
            )
          })}
          <LegendWrap className='legend'>
            <Legend legends={legendData()} colorPallet={colors} />
          </LegendWrap>
        </SegmentWrap>
      )}
    </ContentWrap>
  )
}

export default BuyerTable
